import React from 'react';
import { FormattedMessage } from 'react-intl';
import { number } from 'prop-types';

const propTypes = {
  status: number.isRequired,
};

const defaultProps = {
  status: 0,
};

const TicketsStatus = ({ status, isRead }) => (
  <>
    {status == 0 && (
      <span className="badge badge-success">
        <FormattedMessage id="tickets.status_new" defaultMessage="New" />
      </span>
    )}
    {status == 1 && (
      <span className="badge badge-private">
        <FormattedMessage id="tickets.status_in_process" defaultMessage="In process" />
      </span>
    )}
    {status == 2 && (
      <span className="badge badge-success">
        <FormattedMessage id="tickets.status_answer" defaultMessage="Answer" />{' '}
      </span>
    )}
    {status == 3 && (
      <span className="badge badge-primary">
        <FormattedMessage id="tickets.status_closed" defaultMessage="Closed" />
      </span>
    )}
    {status == 4 && !isRead && (
      <span className="badge badge-success">
        <FormattedMessage id="tickets.status_waiting" defaultMessage="New" />
      </span>
    )}
    {status == 4 && isRead && (
      <span className="badge badge-private">
        <FormattedMessage id="tickets.status_read" defaultMessage="Read" />
      </span>
    )}
  </>
);

TicketsStatus.propTypes = propTypes;
TicketsStatus.defaultProps = defaultProps;

export default TicketsStatus;
